/**
 * Mode context — Casual vs Advanced global toggle.
 */
import React, { createContext, useContext, useState, useMemo } from "react";

const ModeContext = createContext({
    mode: "casual",
    setMode: () => {},
});

export function ModeProvider({ children }) {
    const [mode, setMode] = useState("casual");
    const value = useMemo(() => ({ mode, setMode }), [mode]);
    return (
        <ModeContext.Provider value={value}>{children}</ModeContext.Provider>
    );
}

export function useMode() {
    return useContext(ModeContext);
}
